{
  "actionWithDelay": "Esperar {{seconds}}s, luego {{action}}",
  "areYouSureYouWantToDisconnectTheseDevices": "¿Está seguro de que desea desconectar estos dispositivos?",
  "changesFrom": "Cambios de:",
  "connectDevices": "Conectar dispositivos",
  "newConnection": "Nueva conexión",
  "connectedToTitle": "Conectado a:",
  "connectionsWithConnectionCount": "{{connectionCount}} Conexión(es)",
  "connectedToWithDeviceCount": "Conectado a: {{deviceCount}}",
  "connectionsListTitle": "Conexiones del dispositivo",
  "createTitle": "Conexión de nuevo dispositivo",
  "deleteConnection": "Eliminar conexión",
  "deviceConnectionsListEmpty": "Aún no se han creado conexiones entre dispositivos. Toca \"Conectar dispositivos\" para comenzar.",
  "disconnect": "Desconectar",
  "notificationsDisabled": "Notificaciones deshabilitadas para la conexión",
  "notificationsEnabled": "Notificaciones habilitadas para la conexión",
  "selectedConnectionTitle": "Conexión del dispositivo",
  "sendANotificationWhen": "Enviar una notificación cuando...",
  "sendNotificationsToUsers": "Notificaciones:",
  "source": "Fuente",
  "target": "Objetivo",
  "targetDevice": "Dispositivo de destino"
}
